import { forwardRef } from 'react';

import { Text, type TextProps } from '../Typography';
import { MarkdownCopyToClipboard } from './CopyToClipboardButton.js';
import type { ExtraProps } from './types.js';

export const MarkdownText = forwardRef<HTMLParagraphElement, TextProps & ExtraProps>(
  (props, ref) => {
    const { node, children, ...rest } = props;
    return (
      <Text {...rest} ref={ref}>
        {children}
        <MarkdownCopyToClipboard content={children} />
      </Text>
    );
  }
);
MarkdownText.displayName = 'MarkdownText';
